import { UserType } from "../../../../../login/loginTypes"
import { SupportedAdminTypes } from "../tenantAdminTypes"

//empty key will invalidate all caches and to avoid it check the user type https://tanstack.com/query/v4/docs/framework/react/guides/query-invalidation
export function isSupportedUser({ type }: SupportedAdminTypes) {
    return [UserType.OFFICE_MANAGER, UserType.MERCHANT, UserType.SUPPLIER].includes(type)
}
